import React from 'react';
import { Winners } from 'constants/common';
import { scoreboardColors, ScoreboardColors } from 'widgets/Scoreboard/types';
import { Line } from '../Line';

export type CockroachLineType = Winners.BANKER | Winners.PLAYER;

const lineColorMap: Record<CockroachLineType, string> = {
  [Winners.BANKER]: scoreboardColors[ScoreboardColors.SignalRed],
  [Winners.PLAYER]: scoreboardColors[ScoreboardColors.Blue],
};

export interface ICockroachLine {
  outcome: CockroachLineType;
}

export const CockroachPigLine = ({ outcome }: ICockroachLine) => (
  <Line color={lineColorMap[outcome]} />
);
